import Component from 'vue-class-component'
import moduleStore from '../store/migu';
import Vue from 'vue';
import PageState from '../store/state';
import { toPublishPage } from '../utils/util';

/**components**/
@Component({
})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames
})
export default class VideoPlayPage extends Vue implements IvuePage<PageState> {
  state = new PageState();
  self: Vue = this;
  
  videoUrl: string;
  coverUrl: string;

  created() {
    const url = this.$route.query.videoUrl;
    if(typeof url === 'string') {
      this.videoUrl = url;
    }
    const coverUrl = this.$route.query.coverUrl;
    if(typeof coverUrl === 'string') {
      this.coverUrl = coverUrl;
    }
  }

  mounted() {
    this.$nextTick(() => {
      // 自动播放
      if(this.videoUrl && this.$refs.videoPlayer) {
        (this.$refs.videoPlayer  as any).play();
      }
    })
  }

  toPublish() {
    toPublishPage({
      videoUrl: this.videoUrl,
      coverUrl: this.coverUrl,
    })
  }
}
